export const ADS_SOURCE_ID = 'paybm_confirmation'

export const ADS_BANNER_SIZE = {
  mobile: 'mobile',
  desktop: 'desktop'
}

export const ADS_CONTENT_TYPE = {
  image: 'image',
  html: 'html',
  script: 'script/tag'
}
